import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { faEdit } from '@fortawesome/free-solid-svg-icons';

import { ExamTemplateService } from '../../service/exam-template.service';
import { ExamTemplate } from '../exam-template';

@Component({
  selector: 'mc-exam-template-index',
  templateUrl: './exam-template-index.component.html'
})
export class ExamTemplateIndexComponent implements OnInit {

  editIcon = faEdit;

  public examTemplates: ExamTemplate[];
  private searchTerms: Subject<string> = new Subject<string>()
  requesting: boolean = false;
  @Input() public crudMode: boolean = true;
  @Output() selected: EventEmitter<ExamTemplate> = new EventEmitter<ExamTemplate>();

  constructor(
    private examTemplateService: ExamTemplateService,
    private notifService: ToastrService
  ) {}

  ngOnInit() {
    this.searchTerms.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((term: string) => this.examTemplateService.searchByName(term))
    ).subscribe(
      templates => this.examTemplates = templates,
      error => this.notifService.error(error)
    );
  }

  search(term: string): void {
    if (term.length < 3) { return }
    this.searchTerms.next(term);
  }

  selectedTemplate(template: ExamTemplate): void {
    this.selected.emit(template);
  }

  startRequesting(): void {
    this.requesting = true;
  }

  onRequestingCanceled(): void {
    this.requesting = false;
  }
}
